export default class ImageControl {
    /**
     *
     * @type {ImageControl}
     * @static
     * @memberof ImageControl
     */
    static _instance = null;

    files = [];

    /**
     *
     * @type {Map<string, File}>
     * @memberof ImageControl
     */
    imageFiles = new Map();

    /**
     *
     * @type {Map<string, string>}
     * @memberof ImageControl
     */
    resources = new Map();

    static get Instance() {
        if (this._instance == null) {
            this._instance = new ImageControl();
        }
        return this._instance;
    }
    /**
     * 
     * @param {string} key image name
     * @param {*} file 
     */
    addImage(key) {
        this.files.push(key);
    }
    /**
     * 讀取紀錄使用
     * @param {string[]} files 
     */
    loadData(files) {
        this.files = files;
    }
    /**
     *
     * 目前所有的圖片
     * @readonly
     */
    get getFiles() {
        return this.files;
    }

    addImageFile(key, dataUrl, imageName, file) {
        if (this.resources.has(key)) {
            console.log(`already has ${key}`);
        } else {
            this.resources.set(key, dataUrl);
            this.imageFiles.set(imageName, file);
            this.addImage(imageName);
        }
    }

    async removeImage(imageName) {
        let index = this.files.findIndex((file) => file == imageName)
        if (index > -1) {
            this.files.splice(index, 1)
        }
    }
}